import * as z from "zod/v4";
import { alias } from "../util/alias.ts";

const PACE_LAYER_ALIASES: Record<string, string> = {
  // Canonical (identity, for case-insensitive matching)
  months: "months",
  years: "years",
  decades: "decades",
  centuries: "centuries",
  millennia: "millennia",
  eons: "eons",
  // Common misspelling
  millenia: "millennia",
};

export const PaceLayerSchema = z
  .enum(["months", "years", "decades", "centuries", "millennia", "eons"])
  .describe(
    `What is the time period during which this force's effects will be felt?

Each time period maps roughly to a Pace Layer (c.f. Stewart Brand, Clock of the Long Now):

- months: Fashion
- years: Commerce
- decades: Infrastructure
- centuries: Governance
- millennia: Culture
- eons: Nature
`,
  );

export type PaceLayer = z.infer<typeof PaceLayerSchema>;

export const CoercePaceLayerSchema = z.preprocess(
  alias(PACE_LAYER_ALIASES),
  PaceLayerSchema,
);

export const into = (value: unknown): PaceLayer | undefined => {
  const { data, success } = CoercePaceLayerSchema.safeParse(value);
  if (!success) return undefined;
  return data;
};

export const toDesc = (paceLayer: PaceLayer | undefined): string => {
  switch (paceLayer) {
    case "eons":
      return "Eons";
    case "millennia":
      return "Millenia";
    case "centuries":
      return "Centuries";
    case "decades":
      return "Decades";
    case "years":
      return "Years";
    case "months":
      return "Months";
    default:
      return "Months";
  }
};

export const toLongNowDesc = (paceLayer: PaceLayer | undefined): string => {
  switch (paceLayer) {
    case "eons":
      return "Nature";
    case "millennia":
      return "Culture";
    case "centuries":
      return "Governance";
    case "decades":
      return "Infrastructure";
    case "years":
      return "Commerce";
    case "months":
      return "Fashion";
    default:
      return "Fashion";
  }
};
